import { useContext } from "react";

import { LanguageContext } from "@/contexts/LanguageContext";

export default function useTranslation() {
  return useContext(LanguageContext);
}
